import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { CreatableSelect, Select, AsyncCreatableSelect, AsyncSelect, chakraComponents } from 'chakra-react-select';
import { tokens } from '@everfi/design-system';
import { Box } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
var Combobox = function Combobox(_ref) {
  var options = _ref.options,
    dataAction = _ref.dataAction,
    _ref$closeMenuOnSelec = _ref.closeMenuOnSelect,
    closeMenuOnSelect = _ref$closeMenuOnSelec === void 0 ? false : _ref$closeMenuOnSelec,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    _ref$isAsync = _ref.isAsync,
    isAsync = _ref$isAsync === void 0 ? false : _ref$isAsync,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    id = _ref.id,
    _ref$isCreatable = _ref.isCreatable,
    isCreatable = _ref$isCreatable === void 0 ? false : _ref$isCreatable,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    name = _ref.name,
    onChange = _ref.onChange,
    loadOptions = _ref.loadOptions,
    variant = _ref.variant,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Select...' : _ref$placeholder;
  var chakraReactSelectStyles = {
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    groupHeading: function groupHeading(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        fontSize: '2xs'
      });
    },
    option: function option(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        fontSize: 'sm'
      });
    },
    clearIndicator: function clearIndicator(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        fontSize: 'sm',
        rounded: 'full'
      });
    },
    menu: function menu(provided) {
      return _objectSpread2(_objectSpread2({}, provided), {}, {
        svg: {
          color: 'icon-brand'
        }
      });
    }
  };
  var customComponents = {
    Control: function Control(props) {
      return /*#__PURE__*/React.createElement(chakraComponents.Control, props, /*#__PURE__*/React.createElement(Box, {
        ms: "sm"
      }, /*#__PURE__*/React.createElement(Icon, {
        prefix: "far",
        iconName: "magnifying-glass"
      })), props.children);
    },
    ClearIndicator: function ClearIndicator(props) {
      return /*#__PURE__*/React.createElement(chakraComponents.ClearIndicator, props, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Icon, {
        prefix: "fas",
        iconName: "xmark-circle",
        color: tokens.ColorsGrey500
      })));
    }
  };
  var defaultReactSelectProps = {
    selectedOptionStyle: 'check',
    useBasicStyles: true,
    chakraStyles: _objectSpread2({}, chakraReactSelectStyles),
    tabSelectsValue: false,
    hideSelectedOptions: false,
    colorScheme: 'brand',
    tagVariant: 'subtle'
  };
  var commonProps = _objectSpread2(_objectSpread2({}, defaultReactSelectProps), {}, {
    options: options,
    isMulti: isMulti,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    id: id,
    chakraStyles: chakraReactSelectStyles,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    closeMenuOnSelect: closeMenuOnSelect,
    variant: variant,
    components: customComponents,
    menuPortalTarget: document.body,
    styles: {
      menuPortal: function menuPortal(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          zIndex: 'var(--udl-zIndices-popover, 1500)'
        });
      }
    }
  });
  if (!isAsync) {
    var SelectComponent = isCreatable ? CreatableSelect : Select;
    return /*#__PURE__*/React.createElement(SelectComponent, _extends({}, commonProps, {
      "data-object-type": "core-combobox",
      "data-action": dataAction
    }));
  }
  var AsyncSelectComponent = isCreatable ? AsyncCreatableSelect : AsyncSelect;
  return /*#__PURE__*/React.createElement(AsyncSelectComponent, _extends({}, commonProps, {
    loadOptions: loadOptions,
    "data-object-type": "core-combobox-async",
    "data-action": dataAction
  }));
};
Combobox.displayName = "Combobox";
export { Combobox };